import(/* webpackMode: "eager" */ "/vercel/path0/src/app/toplu-teklif/page.tsx");
